__turbopack_context__.v({
  "actionsContainer": "UJvPWa_actionsContainer",
  "applyButton": "UJvPWa_applyButton",
  "arrowDown": "UJvPWa_arrowDown",
  "button": "UJvPWa_button",
  "crossIcon": "UJvPWa_crossIcon",
  "dialog": "UJvPWa_dialog",
  "labelCopy": "UJvPWa_labelCopy",
});
